import React, { Component } from 'react';
import {properties} from '../environments';

const BC_EXPLORER = properties.BLOCKCHAIN_EXPLORER;

class BCExpl extends Component {

  render() {
        return <iframe width="100%" height="100%" src="http://54.229.157.131:4050/#" frameborder="0" allowfullscreen></iframe>;
  }
}

export default BCExpl;



// WEBPACK FOOTER //
// ./src/containers/BCExpl.js